import { LadlesMaintenancePage } from "./LadleMaintenancePage";

type Props = {};
const LadlesMaintenance = (props: Props) => {
  return <LadlesMaintenancePage />;
};
export default LadlesMaintenance;
